import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  static getDerivedStateFromError() {
    return { error: true };
  }

  componentDidCatch(error, info) {
    console.error("Erreur d'affichage :", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-paper px-6 text-center">
          <div>
            <p className="font-serif text-3xl">Une page s'est mal affichée.</p>
            <button
              onClick={() => (window.location.href = "/")}
              data-testid="error-boundary-home-button"
              className="mt-6 btn-primary"
            >
              Retour à l'accueil
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
